// extracted by mini-css-extract-plugin
export default {"divMessage":"ProductNotFound_divMessage__ikS8+","btnHome":"ProductNotFound_btnHome__qgUgl"};